module.exports = __webpack_public_path__ + "files/65d91138168857b4e00423137fdbe33d.png";